import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { includes, isNil } from 'lodash';
import { fileSize as humanizeFileSize } from 'humanize-plus';

import withMessages from 'component-utilities/intl';
import RetinaImage from 'v-c/RetinaImage';

import CompleteImage from './images/complete.png';
import ErrorImage from './images/error.png';
import PendingImage from './images/pending.png';
import RunnningImage from './images/running.png';
import ScheduledImage from './images/scheduled.png';
import ExpiredImage from './images/expired.png';

const statusImages = {
    complete: CompleteImage,
    done: CompleteImage,
    error: ErrorImage,
    pending: PendingImage,
    running: RunnningImage,
    scheduled: ScheduledImage,
    expired: ExpiredImage,
};

@withMessages
export default class JobStatusCell extends Component {
    static propTypes = {
        type: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired,
        status: PropTypes.string.isRequired,
        downloadAction: PropTypes.func.isRequired,
        files: PropTypes.array.isRequired,
        getMessage: PropTypes.func.isRequired,
        finishedStates: PropTypes.array.isRequired,
        prefix: PropTypes.string.isRequired,
    };

    download = () => {
        const { id, type, status, downloadAction } = this.props;

        if (includes(this.props.finishedStates, status)) {
            downloadAction(id, type);
        }
    };

    render() {
        const { status, type, files, getMessage, prefix } = this.props;
        let fileSize;
        if (files[0]) {
            fileSize = files[0]['file-size'];
        }

        const statusMessage = getMessage(`${prefix}.job_statuses.${status}`);
        const statusImage = statusImages[status];

        return (
            <span
                onClick={this.download}
                data-cell-type={`jobs-${type}`}
                data-can-download={includes(this.props.finishedStates, status)}
                role="button"
                tabIndex={-1}
                className="job-status"
            >
                { statusImage && <RetinaImage image={statusImage} /> }
                { statusMessage }
                { !isNil(fileSize) && ` (${humanizeFileSize(fileSize)})` }
            </span>
        );
    }
}
